import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import { Wrapper, Text, Button } from './elements';

import { useText } from 'common/hooks';
import { LEADERBOARD_TAB } from 'resources/constants';

const deps = {
  campaign: state.challenge.campaign,
  selectedLeaderboardTab: state.challenge.visualisations.selectedLeaderboardTab,
  leaderboardTabClicked: sequences`challenge.visualisations.leaderboardTabClicked`,
};

function Menu({
  campaign,
  selectedLeaderboardTab,
  leaderboardTabClicked,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  const sectionCount = Object.keys(campaign?.structure.sections || {}).length;
  let sectionTabName = t('challenge.toplist.menu.your_organisation');

  if (campaign.sectionTerm === 'other') {
    sectionTabName = campaign.specifiedTerm;
  } else if (campaign.sectionTerm) {
    sectionTabName = t(
      `challenge.toplist.menu.your_section.${campaign.sectionTerm}`,
      {
        smart_count: 1,
      }
    );
  }

  return (
    <Wrapper>
      <Button
        onClick={() => leaderboardTabClicked({ tab: LEADERBOARD_TAB.team })}
        active={selectedLeaderboardTab === LEADERBOARD_TAB.team}
      >
        <Text active={selectedLeaderboardTab === LEADERBOARD_TAB.team}>
          {t('challenge.toplist.menu.your_team')}
        </Text>
      </Button>
      {campaign ? (
        <Button
          onClick={() =>
            leaderboardTabClicked({ tab: LEADERBOARD_TAB.section })
          }
          active={selectedLeaderboardTab === LEADERBOARD_TAB.section}
        >
          <Text active={selectedLeaderboardTab === LEADERBOARD_TAB.section}>
            {sectionTabName}
          </Text>
        </Button>
      ) : null}
      {sectionCount > 1 ? (
        <Button
          onClick={() =>
            leaderboardTabClicked({ tab: LEADERBOARD_TAB.challenge })
          }
          active={selectedLeaderboardTab === 'challenge'}
        >
          <Text active={selectedLeaderboardTab === LEADERBOARD_TAB.challenge}>
            {t('challenge.toplist.menu.your_organisation')}
          </Text>
        </Button>
      ) : null}
      {campaign?.championshipKey ? (
        <Button
          onClick={() =>
            leaderboardTabClicked({ tab: LEADERBOARD_TAB.championship })
          }
          active={selectedLeaderboardTab === 'championship'}
        >
          <Text
            active={selectedLeaderboardTab === LEADERBOARD_TAB.championship}
          >
            {t('challenge.toplist.menu.all_organisations')}
          </Text>
        </Button>
      ) : null}
    </Wrapper>
  );
}

export default connect(deps, Menu);
